module.exports = __webpack_public_path__ + "img/card-visa.17821423.svg";